import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { IncomingOutgoingAmlContent, TransactionTypeEnum } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemIncomingTransaction from '../hooks/use-incoming';

const ProblemIncomingTransactionAmlContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();

  const { aml } = useAppSelector(
    (state) => state.customersProblemTransactions.incoming,
  );

  const { getIncomingAmlAction, isLoadingAml } = useProblemIncomingTransaction({
    transactionId,
  });

  useEffect(() => {
    if (!aml && transactionId) {
      getIncomingAmlAction();
    }
  }, [getIncomingAmlAction, aml, transactionId]);

  return (
    <IncomingOutgoingAmlContent
      isLoading={isLoadingAml}
      aml={aml}
      transactionType={TransactionTypeEnum.INCOMING}
    />
  );
};

export default ProblemIncomingTransactionAmlContentHOC;
